import { arrayUnion, doc, getDoc, serverTimestamp, setDoc } from 'firebase/firestore';
import { useEffect, useState } from 'react';
import { db } from '.';
import { COLLECTION } from '../helper/collections';

// Billing B1.5: the admin "all Sundays" switch, one document: settings/sundays.
// Missing document, or a read error → all Sundays closed (the safe side).
const sundaysRef = () => doc(db, COLLECTION.SETTINGS, 'sundays');

let sundaysRead = null;

const readAllSundaysOpen = async () => {
  try {
    const snapshot = await getDoc(sundaysRef());
    return snapshot.exists() && snapshot.data().allOpen === true;
  } catch (e) {
    console.error('Could not read the Sundays setting', e);
    sundaysRead = null; // try again next time
    return false;
  }
};

// One read per page load, shared by search and the booking calendar.
export const getAllSundaysOpen = () => {
  if (!sundaysRead) {
    sundaysRead = readAllSundaysOpen();
  }
  return sundaysRead;
};

export const getSundaysSetting = async () => {
  const snapshot = await getDoc(sundaysRef());
  return snapshot.exists() ? snapshot.data() : { allOpen: false };
};

export const setAllSundaysOpen = async (allOpen, userId) => {
  const by = userId || null;
  // history: one line per change, never edited (the browser's time; changedAt is the server's)
  await setDoc(
    sundaysRef(),
    {
      allOpen: allOpen === true,
      changedAt: serverTimestamp(),
      changedBy: by,
      history: arrayUnion({ allOpen: allOpen === true, at: new Date().toISOString(), by })
    },
    { merge: true }
  );
  sundaysRead = Promise.resolve(allOpen === true);
};

export const useAllSundaysOpen = () => {
  const [allOpen, setAllOpen] = useState(false);
  useEffect(() => {
    let active = true;
    getAllSundaysOpen().then((value) => active && setAllOpen(value));
    return () => {
      active = false;
    };
  }, []);
  return allOpen;
};
